"use strict";
(function (window, document, com, undefined) {

    const init = () => {
        lazy.init();
        title.init();
        menu.init();
        countdown.init();
        helper.event(document, 'scroll', scroll.parallax);

        // form validation
        let btn = helper.element(".validate", false);
        let fields = [];
        Object.values(helper.element(".js-required", true)).forEach(function(item, k) {
            fields.push(item);
        });
        Object.values(helper.element(".js-validate", true)).forEach(function(item, k) {
            fields.push(item);
        });
        let form = helper.element(".js-form", false);
        eventvalidation(btn, fields, form);

    }

    const eventvalidation = (btn, fields, form) => {
        if (btn && (btn.length > 0 || typeof btn.length === "undefined") && form) {

            if (fields) {
                if (helper.validate(fields, false)) {
                    btn.classList.remove("disabled");
                } else {
                    btn.classList.add("disabled");
                }
            }

            Object.values(fields).forEach(function (item, k) {
                if (item.type !== "radio" && item.type !== "checkbox" && item.type !== "password") {
                    item.addEventListener( "input", event => {
                        item.value = item.value.replace(/[^a-zA-Z0-9.!@#$%&'*+\/=?^_{|}-\s]/gm, '');
                    });
                    item.addEventListener( "paste", event => {
                        item.value = item.value.replace(/[^a-zA-Z0-9.!@#$%&'*+\/=?^_{|}-\s]/gm, '');
                    });
                }

                ['keyup', 'blur', 'touchstart', 'click'].forEach(function (e) {
                    item.addEventListener(e, function (evt) {
                        item.classList.add("validated");
                        if (fields) {
                            if (helper.validate(fields, false)) {
                                btn.classList.remove("disabled");
                            } else {
                                btn.classList.add("disabled");
                            }
                        }
                    });
                });
            });

            helper.event(btn, 'click touchstart', function (e) {
                if (!btn.classList.contains("disabled")) {
                    if (helper.validate(fields, true)) {
                        e.preventDefault();
                        form.submit();
                    } else {
                        btn.classList.add("disabled");
                    }
                }
            });

        }
    };


    init();

})(
    window,
    document,
    {
        helper,
        title,
        scroll,
        lazy,
        menu,
        countdown
    },
    undefined
);